var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMedal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 36,
    viewBox: "0 0 32 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Medal"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Regular"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 3.1547C15.2376 2.44017 16.7624 2.44017 18 3.1547L27.8564 8.8453C29.094 9.55983 29.8564 10.8803 29.8564 12.3094V23.6906C29.8564 25.1197 29.094 26.4402 27.8564 27.1547L18 32.8453C16.7624 33.5598 15.2376 33.5598 14 32.8453L4.14359 27.1547C2.90599 26.4402 2.14359 25.1197 2.14359 23.6906V12.3094C2.14359 10.8803 2.90599 9.55983 4.14359 8.8453L14 3.1547Z",
    fill: "#10151B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 2.28868C16.953 1.39551 15.047 1.39551 13.5 2.28868L3.64359 7.97927C2.09659 8.87244 1.14359 10.5231 1.14359 12.3094V23.6906C1.14359 25.4769 2.09659 27.1276 3.64359 28.0207L13.5 33.7113C15.047 34.6045 16.953 34.6045 18.5 33.7113L28.3564 28.0207C29.9034 27.1276 30.8564 25.4769 30.8564 23.6906V12.3094C30.8564 10.5231 29.9034 8.87244 28.3564 7.97927L18.5 2.28868Z",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedal);
export default __webpack_public_path__ + "static/media/medal.78d16bede4847474f85d0c52c00da522.svg";
export { ForwardRef as ReactComponent };